import * as api from '../api/keys.js';
import q from '../query.js';
import keys from '@debbie/common/dist/cache/keys.js';
export const keysEntity = 'keys';
const keyByIdKey = (id) => `keys-${id}`;
export const getKeyById = (id) => q.query(keyByIdKey(id), () => api.getById(id), keys.read.item(keysEntity, id));
//# sourceMappingURL=index.js.map